export default function getShare(value, total) {
  return total !== 0 && value !== 0 ? value / total : 0;
}
